import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { useOvertimeDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/OvertimeDashboard/store/overtimeDashboard.store';
import { DATA_TABLE_PAGE_SIZE } from 'pages/ReportsPage/components/AnalyticsDashboards/OvertimeDashboard/OvertimeDashboard.constants';
import { DataTable } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/DataTable';
import { DataTableColumn } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/FulfillmentDashboard.types';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OvertimeDashboard/OvertimeDashboard.styled';

export const TopOvertimeIndividualsTable: React.FC = () => {
  const { t } = useTranslation();
  const data = useOvertimeDashboardStore((s) => s.overtimeIndividuals);
  const individualsPage = useOvertimeDashboardStore((s) => s.individualsPage);
  const individualsTotalPages = useOvertimeDashboardStore((s) => s.individualsTotalPages);
  const individualsLoading = useOvertimeDashboardStore((s) => s.individualsLoading);
  const fetchIndividualsPage = useOvertimeDashboardStore((s) => s.fetchIndividualsPage);

  const columns: DataTableColumn[] = useMemo(
    () => [
      { key: 'teamMemberId', label: t('reports:OVERTIME_COL_TEAM_MEMBER_ID') },
      { key: 'teamMemberName', label: t('reports:OVERTIME_COL_TEAM_MEMBER_NAME') },
      { key: 'teamMemberType', label: t('reports:OVERTIME_COL_TEAM_MEMBER_TYPE') },
      {
        key: 'overtimeHours',
        label: t('reports:OVERTIME_COL_OVERTIME_HOURS'),
        align: 'right' as const,
      },
    ],
    [t],
  );

  const rows = useMemo(
    () =>
      data?.map((d) => ({
        teamMemberId: d.teamMemberId,
        teamMemberName: d.teamMemberName,
        teamMemberType: d.teamMemberType,
        overtimeHours: d.overtimeHours,
      })) ?? [],
    [data],
  );

  const handlePageChange = useCallback(
    (page: number) => fetchIndividualsPage(page),
    [fetchIndividualsPage],
  );

  if (!data || (data.length === 0 && individualsTotalPages <= 1)) {
    return <EmptyStateContainer>{t('reports:OVERTIME_NO_DATA')}</EmptyStateContainer>;
  }

  return (
    <DataTable
      columns={columns}
      rows={rows}
      pageSize={DATA_TABLE_PAGE_SIZE}
      ariaLabel={t('reports:OVERTIME_INDIVIDUALS_TITLE')}
      serverPagination={{
        currentPage: individualsPage,
        totalPages: individualsTotalPages,
        onPageChange: handlePageChange,
        isLoading: individualsLoading,
      }}
    />
  );
};
